import { IUser } from '@/@types'
import { Svg } from '@/components'
import { ColumnHeader } from '@/components/data-table/column-header'
import { ColumnDef } from '@tanstack/react-table'
import { format } from 'date-fns'
import { TablePaymentStatus } from './table-payment-status'

export const TABLE_COLUMNS: ColumnDef<IUser>[] = [
  {
    id: 'name',
    accessorKey: 'name',
    header: ({ column }) => <ColumnHeader column={column} title="Nome" />,
    cell: ({ row }) => (
      <div className="flex gap-2 items-center">
        <Svg src="/icons/student.svg" className="max-w-6" />
        <span>{row.original.name + ' ' + row.original.surname}</span>
      </div>
    ),
    filterFn: (row, id, value) =>
      String(row.getValue(id))
        .toLowerCase()
        .includes(String(value).toLowerCase()),
  },
  {
    id: 'level',
    accessorKey: 'level',
    header: ({ column }) => <ColumnHeader column={column} title="Nível" />,
    cell: ({ row }) => `Nível ${row.original.level}`,
  },
  {
    id: 'phoneNumber',
    accessorKey: 'phoneNumber',
    header: ({ column }) => <ColumnHeader column={column} title="Contacto" />,
    cell: ({ row }) => row.original.phoneNumber || row.original.email || '-',
  },
  {
    id: 'lastPaymentData',
    accessorKey: 'lastPaymentData',
    header: ({ column }) => (
      <ColumnHeader column={column} title="Último Pagamento" />
    ),
    cell: ({ row }) =>
      row.original.lastPaymentData
        ? format(row.original.lastPaymentData, 'dd/MM/yyyy')
        : '-',
  },
  {
    id: 'signature',
    accessorKey: 'signature',
    header: ({ column }) => (
      <ColumnHeader column={column} title="Estado do Pagamento" />
    ),
    cell: ({ row }) => <TablePaymentStatus data={row.original} />,
    filterFn: (row, _, value) => {
      const signature = row.original.signature

      if (!value || value.length === 0) {
        return true
      }

      return value.includes(signature)
    },
  },
]
